
import GwQuote from '~/patterns/atoms/quote/quote.vue';
import GwBackdrop from '~/patterns/atoms/backdrop/backdrop.vue';
import GwPageContainer from '~/patterns/molecules/page-container/page-container.vue';

export default {
    components: {
        GwQuote,
        GwBackdrop,
        GwPageContainer
    },

    props: {
        autoQuote: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            visiblePercentage: 0
        };
    },

    methods: {
        viewHandler(event) {
            this.visiblePercentage = Math.round(event.percentCenter * 100);
        }
    }
};
